// frontend/source/portal/components/EditArtTagCard.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImagePicker from "./ImagePicker";
import "./EditArtTagCard.css";

const EditArtTagCard = ({ artTag, onDelete, onUpdate, categoryId }) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(artTag.name);
  const [isSaving, setIsSaving] = useState(false);
  const [showImagePicker, setShowImagePicker] = useState(false);

  const handleSave = async () => {
    if (name.trim() === "") {
      alert("Art tag name cannot be empty");
      return;
    }

    if (name === artTag.name) {
      setIsEditing(false);
      return;
    }

    try {
      setIsSaving(true);
      await onUpdate(artTag._id, { name });
      setIsEditing(false);
    } catch (err) {
      setName(artTag.name);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    setName(artTag.name);
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleImageSelect = async (imageUrl) => {
    try {
      setIsSaving(true);
      await onUpdate(artTag._id, { image: imageUrl });
    } catch (err) {
      console.error("Failed to update image:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleManageArtworks = () => {
    navigate(`/portal/category/${categoryId}/tag/${artTag._id}`);
  };

  return (
    <div className="edit-arttag-card">
      <div className="edit-arttag-card-image-container">
        <img
          src={artTag.image}
          alt={artTag.name}
          onClick={handleManageArtworks}
          className="edit-arttag-card-image"
        />
        <button
          onClick={() => setShowImagePicker(true)}
          className="edit-arttag-change-image-btn"
          title="Change image"
        >
          📷
        </button>
      </div>
      <div className="edit-arttag-card-overlay">
        {isEditing ? (
          <div className="edit-arttag-input-container">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleKeyPress}
              className="edit-arttag-input"
              autoFocus
              disabled={isSaving}
            />
            <div className="edit-arttag-buttons">
              <button
                onClick={handleSave}
                className="edit-arttag-btn save-btn"
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
              <button
                onClick={handleCancel}
                className="edit-arttag-btn cancel-btn"
                disabled={isSaving}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <>
            <h2 className="edit-arttag-card-title">{artTag.name}</h2>
            <div className="edit-arttag-actions">
              <button
                onClick={() => setIsEditing(true)}
                className="edit-arttag-action-btn edit-btn"
                title="Edit art tag name"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(artTag._id)}
                className="edit-arttag-action-btn delete-btn"
                title="Delete art tag"
              >
                Delete
              </button>
            </div>
          </>
        )}
      </div>

      {showImagePicker && (
        <ImagePicker
          currentImage={artTag.image}
          onImageSelect={handleImageSelect}
          onClose={() => setShowImagePicker(false)}
        />
      )}
    </div>
  );
};

export default EditArtTagCard;
